import { Pipe, PipeTransform } from '@angular/core';

import { PhonePipe } from './phone.pipe';

@Pipe({
  name: 'contact'
})
export class ContactPipe extends PhonePipe implements PipeTransform {
  transform(value: string): any {
    value = value.replace(/\s/, '');

    if (value.indexOf('@') === -1) {
      return super.transform(value);
    }

    return value;
  }
}
